
import React from 'react';
import PageHeader from '@/components/PageHeader';
import { Card, CardContent } from '@/components/ui/card';
import WebsiteChatModal from '@/components/website-help/WebsiteChatModal';

const WebsiteHelp = () => {
  return (
    <div className="min-h-screen bg-secondary">
      <PageHeader 
        title="Ayuda con la Plataforma" 
        description="Resuelve tus dudas sobre cómo usar nuestra plataforma"
      />
      
      <div className="container max-w-4xl mx-auto py-8 px-4">
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Asistente Virtual</h2>
          <p className="text-muted-foreground">
            Este asistente está diseñado exclusivamente para responder preguntas sobre cómo usar nuestra plataforma web y aplicación móvil. 
            Para preguntas sobre inmigración, por favor regresa a la página principal y utiliza nuestro Asistente Legal.
          </p>
        </div>
        
        <Card className="w-full max-w-2xl mx-auto shadow-md">
          <CardContent className="p-0">
            <div className="h-[500px]">
              <WebsiteChatModal onClose={() => {}} />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default WebsiteHelp;
